module.exports = __webpack_public_path__ + "static/media/rekomendasi.7c270baa.svg";